module.exports = __webpack_public_path__ + "img/the-stone-sky.cd9b7e2e.png";